import React from "react";

import { Typography } from "antd";
import styled from "styled-components";

const { Paragraph } = Typography;

interface ICopyableTextProps {
  size?: number;
  color?: string;
}

const CopyableTextContainer = styled(Paragraph)<ICopyableTextProps>`
  padding: 0 !important;
  margin: 0 !important;
  line-height: 1.2;
  font-size: ${({ size }) => size || 14}px;
  ${({ color }) =>
    color &&
    `
    color: ${color};
  `}
`;

const CopyableText: React.FC<ICopyableTextProps> = ({
  children,
  color,
  size,
}) => (
  <CopyableTextContainer color={color} size={size} copyable>
    {children}
  </CopyableTextContainer>
);

export default CopyableText;
